import React, { Component } from "react";
import moment from "moment";

import CustomModal from "./CustomModal";
import FromStart from "./FromStart";
import InRange from "./InRange";

import ExportExcel from "../../../components/ExportExcelNew";
import { DatePickerR } from "../../../components/DatePickerR";
import { FilterItem } from "../../../components/FilterItemNew/FilterItem";
import { FilterWrapper } from "../../../components/FilterWrapper/FilterWrapper";
import { MainWrapper } from "../../../components/MainWrapper/MainWrapper";
import { RowWrapper } from "../../../components/RowWrapper/RowWrapper";
import { SelectList } from "../../../components/SelectList/SelectList";
import cubejs from "../../../cube";
import i18n from "../../../i18n";

const cubejsApi = cubejs({ appId: 1 });
export default class AppealsCitizen extends Component {
  state = {
    range: [
      moment().startOf("month").utc(6).startOf("day"),
      moment().utc(6).endOf("day"),
    ],
    showModal: false,
    name: null,
    type: null,
    exportData: [],
    regions: [],
    disabledRegion: false,
    disabledDistrict: false,
    selectedRegions: [],
    districts: [],
    selectedDistricts: [],
    isFromStart: false,
  };

  toggleShowModal = (e, name, isFromStart) => {
    let type = typeof e === "string" ? e : null;
    this.setState({
      showModal: !this.state.showModal,
      type,
      name,
      isFromStart,
    });
  };

  async componentDidMount() {
    let role = JSON.parse(localStorage.getItem("user_params"));
    this.loadDictionaries();
    if (role?.roles?.[0]?.region?.length) {
      this.checkForRegion();
    } else {
      this.getData();
    }
  }

  checkForRegion = () => {
    let role = JSON.parse(localStorage.getItem("user_params"));
    if (role?.roles?.[0]?.region?.length) {
      const selectedRegions = role.roles[0].region
        .filter((region) => !region?.parentId)
        .map((region) => region.regionName);

      /*
       * Эта часть кода была создана специально
       * для учетных записей user-krg-bkh и
       * user-krg-kzb. Данный кейс является
       * уникальным, поэтому логика
       * прописывалась исключительно под них.
       */

      let krgDistrict = [];

      if (role.userId === 44) {
        krgDistrict = [role.roles[0].region[0].child[0].regionName];
      } else if (role.userId === 45) {
        krgDistrict = [role.roles[0].region[0].child[1].regionName];
      }

      this.setState(
        {
          selectedRegions,
          selectedDistricts: krgDistrict,
          disabledRegion: true,
          disabledDistrict: krgDistrict.length || false,
        },
        () => this.getData()
      );
    }
  };

  loadDictionaries = async () => {
    const regions = await cubejsApi.load({
      dimensions: ["Appeals.region"],
    });
    this.setState({
      regions: regions.rawData(),
    });
  };

  applyFilters = (filter, values) => {
    const { regions, selectedRegions } = this.state;
    if (filter === "selectedRegions" && !values.length) {
      this.setState({ selectedDistricts: [] });
    }
    if (filter === "selectedRegions" && selectedRegions.length === 0) {
      const districtObject = regions.find(
        (district) => district["Appeals.region"] === values[0]
      );
      const regionObject = regions?.find(
        (region) =>
          region["Appeals.region"] === districtObject["Appeals.region"]
      );
      this.setState({
        selectedRegions: [regionObject["Appeals.region"]],
      });
    }
    this.setState({
      [filter]: values,
    });
  };

  handleRange = (val) => {
    this.setState({ range: val }, this.getData);
  };

  getData = () => {
    const { range, selectedDistricts, selectedRegions } = this.state;
    const filters = [
      {
        member: "Appeals.submissionDate",
        operator: "inDateRange",
        values: range,
      },
    ];

    if (selectedRegions?.length) {
      filters.push({
        member: "Appeals.region",
        operator: "equals",
        values: selectedRegions,
      });
    }
    if (selectedDistricts?.length) {
      filters.push({
        member: "Appeals.district",
        operator: "equals",
        values: selectedDistricts,
      });
    }
    let query = [
      {
        measures: ["Appeals.appealsNum"],
        dimensions: ["Appeals.appealType", "Appeals.source"],
        filters: [
          {
            member: "Appeals.appealType",
            operator: "contains",
            values: ["Запрос"],
          },
        ],
        order: {
          "Appeals.source": "asc",
        },
        renewQuery: true,
      },
      {
        measures: ["Appeals.appealsNum"],
        dimensions: ["Appeals.appealType", "Appeals.source"],
        filters: [
          {
            member: "Appeals.appealType",
            operator: "contains",
            values: ["Жалоба"],
          },
        ],
        order: {
          "Appeals.source": "asc",
        },
        renewQuery: true,
      },
      {
        measures: ["Appeals.appealsNum"],
        dimensions: ["Appeals.appealType", "Appeals.source"],
        filters: [
          {
            member: "Appeals.appealType",
            operator: "contains",
            values: ["Заявление"],
          },
        ],
        order: {
          "Appeals.source": "asc",
        },
        renewQuery: true,
      },
      {
        measures: ["Appeals.appealsNum"],
        dimensions: ["Appeals.appealType", "Appeals.source"],
        filters: [
          {
            member: "Appeals.appealType",
            operator: "contains",
            values: ["Иное"],
          },
        ],
        order: {
          "Appeals.source": "asc",
        },
        renewQuery: true,
      },
      {
        measures: ["Appeals.appealsNum"],
        dimensions: ["Appeals.appealType", "Appeals.source"],
        filters: [
          {
            member: "Appeals.appealType",
            operator: "contains",
            values: ["Предложение"],
          },
        ],
        order: {
          "Appeals.source": "asc",
        },
        renewQuery: true,
      },
      {
        measures: ["Appeals.appealsNum"],
        dimensions: ["Appeals.appealType", "Appeals.source"],
        filters: [
          {
            member: "Appeals.appealType",
            operator: "contains",
            values: ["Благодарность"],
          },
        ],
        order: {
          "Appeals.source": "asc",
        },
        renewQuery: true,
      },
      {
        measures: ["Appeals.appealsNum"],
        dimensions: ["Appeals.appealType", "Appeals.source"],
        filters: [
          {
            member: "Appeals.appealType",
            operator: "contains",
            values: ["Отклик"],
          },
        ],
        order: {
          "Appeals.source": "asc",
        },
        renewQuery: true,
      },
    ];
    query = query.map((e) => cubejsApi.load(e));
    Promise.all(query).then((r) => {
      this.setState({
        exportData: [
          ...r[0].rawData(),
          ...r[1].rawData(),
          ...r[2].rawData(),
          ...r[3].rawData(),
          ...r[4].rawData(),
          ...r[5].rawData(),
          ...r[6].rawData(),
        ],
      });
    });
  };

  filterRegions = () => {
    const { regions } = this.state;
    return regions.map((it) => it["Appeals.region"]);
  };

  render() {
    const {
      range,
      selectedRegions,
      selectedDistricts,
      regions,
      disabledRegion,
      disabledDistrict,
      isFromStart,
    } = this.state;

    return (
      <MainWrapper>
        <FilterWrapper>
          <FilterItem>
            <SelectList
              label={i18n.t("education.pupilsBySchool.locality")}
              mode="multiple"
              value={selectedRegions}
              onChange={(value) => this.applyFilters("selectedRegions", value)}
              defaultValue={[]}
              disabled={disabledDistrict}
              size="small"
              allowClear
              list={this.filterRegions()}
            />
          </FilterItem>
          <FilterItem>
            <DatePickerR
              label={i18n.t("economy.income.period")}
              onChange={this.handleRange}
              showTime={{
                secondStep: 60,
                minuteStep: 15,
              }}
              allowClear={false}
              value={range}
              size="small"
              separator="—"
            />
          </FilterItem>
          <FilterItem action>
            <ExportExcel
              filename={`Отчет по источникам обращений
              (${selectedRegions.length !== 0 ? selectedRegions : ""}, ${
                selectedDistricts.length !== 0 ? selectedDistricts : ""
              }) за ${range[0].format(
                "YYYY-MM-DD HH:mm:ss"
              )} – ${range[1].format("YYYY-MM-DD HH:mm:ss")}`}
              data={this.state.exportData}
              fields={[
                {
                  dataIndex: "Appeals.appealType",
                  title: "Тип",
                },
                {
                  dataIndex: "Appeals.source",
                  title: "Источник",
                },
                {
                  dataIndex: "Appeals.appealsNum",
                  title: "Количество",
                },
              ]}
            />
          </FilterItem>
        </FilterWrapper>
        <RowWrapper>
          <FromStart
            toggleShowModal={this.toggleShowModal}
            regions={selectedRegions}
            districts={selectedDistricts}
          />
          <InRange
            toggleShowModal={this.toggleShowModal}
            regions={selectedRegions}
            districts={selectedDistricts}
            range={range}
          />
        </RowWrapper>

        <CustomModal
          district={selectedDistricts}
          region={selectedRegions}
          type={this.state.type}
          name={this.state.name}
          showModal={this.state.showModal}
          toggleShowModal={this.toggleShowModal}
          isFromStart={isFromStart}
          filters={{
            member: "Appeals.submissionDate",
            operator: "inDateRange",
            values: range,
          }}
        />
      </MainWrapper>
    );
  }
}
